const TimeIcon = ({ ...props }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_6546_141865)">
                <path
                    d="M10.0347 17.5585C14.1906 17.5585 17.5596 14.1895 17.5596 10.0336C17.5596 5.87769 14.1906 2.50867 10.0347 2.50867C5.87879 2.50867 2.50977 5.87769 2.50977 10.0336C2.50977 14.1895 5.87879 17.5585 10.0347 17.5585Z"
                    stroke="#2F68E3"
                    strokeWidth="1.31686"
                />
                <path
                    d="M10.0332 5.89191V10.3794C10.0332 10.5284 10.2133 10.603 10.3187 10.4977L12.2906 8.52564"
                    stroke="#2F68E3"
                    strokeWidth="1.31686"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_6546_141865">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
export default TimeIcon
